<template>
    <p>
        <strong>Ampelsystem:</strong>
        <span class="c-ranking c-ranking--red"></span> in mehreren Kolonnen eingeplant
        <span class="c-ranking c-ranking--yellow u-extra-small-margin--left"></span> ist nicht verfügbar
    </p>
</template>
<script>
    export default {
        name: 'KolonneSettingsCrudEmployeesRankingLegend'
    }
</script>
